import Breadcrumbs from '@mui/material/Breadcrumbs';
import MuiLink from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import { Link } from 'react-router-dom';
import IconButton from '../IconButton/IconButton';
import { ChevronRightIcon, HomeIcon } from '../icons';

const PortalComponent = ({ children }) => {
  const targetElement = document.getElementById('breadcrumbs-portal');
  return targetElement ? ReactDOM.createPortal(children, targetElement) : null;
};

const Breadcrumb = ({ breadcrumbs, disablePortal, ...props }) => {
  const content = (
    <Breadcrumbs
      separator={<ChevronRightIcon fontSize="small" />}
      sx={{
        '& .MuiBreadcrumbs-separator:first-of-type': {
          ml: 0,
        },
      }}
      {...props}
    >
      <IconButton
        size="small"
        color="secondary"
        icon={<HomeIcon fontSize="large" />}
        variant="text"
        to="/"
      />
      {breadcrumbs.map(({ path, title }, index) => {
        return path ? (
          <MuiLink
            key={index}
            component={Link}
            to={path}
            sx={{ fontWeight: 600, color: 'text.secondary' }}
          >
            {title}
          </MuiLink>
        ) : (
          <Typography color="text.subtle" fontWeight={600} key={index}>
            {title}
          </Typography>
        );
      })}
    </Breadcrumbs>
  );

  if (disablePortal) return content;

  return <PortalComponent>{content}</PortalComponent>;
};

Breadcrumb.propTypes = {
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string,
      title: PropTypes.string.isRequired,
    }).isRequired,
  ),
};

export default Breadcrumb;
